import "./../App.css"
import Header from "../components/Header"
import NewsComponent from "../components/NewsComponent/NewsComponent"
import Stack from "@mui/material/Stack"
import Divider from "@mui/material/Divider"
import Slideshow from "../components/SliderComponent/SliderComponent"
import { Typography } from "@mui/material"

function HomePage() {
	return (
		<div className="content">
			<Header title="Inicio" />
			<br></br>
			<Slideshow />
			<br></br>
			<Typography variant="h3" gutterBottom>
				Actualidad
			</Typography>
			<Stack
				direction="column"
				spacing={1}
				divider={<Divider orientation="horizontal" flexItem />}
			>
				<NewsComponent />
			</Stack>
		</div>
	)
}

export default HomePage
